import React from 'react';
import SubscriptionList from "../containers/SubscriptionList/SubscriptionList";

const SubscriptionListPage: React.FC = () => <SubscriptionList />;

export default SubscriptionListPage;
